import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Calendar, Mail, Clock } from 'lucide-react';

const ThankYou = () => {
  return (
    <div className="page-thankyou">
      <div className="container">
        <div className="thankyou-content">
          <div className="thankyou-icon">
            <CheckCircle size={64} strokeWidth={1.5} />
          </div>
          
          <h1 className="heading-1">Thank You!</h1>
          <p className="thankyou-subtitle">
            Your intake form has been successfully submitted.
          </p>
          
          <div className="thankyou-message">
            <p className="body-large">
              We&apos;ve received your information and our care team is reviewing it now. 
              You&apos;re one step closer to feeling like yourself again.
            </p>
          </div>

          <div className="thankyou-steps">
            <h2 className="heading-3">What Happens Next</h2>
            
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-icon">
                  <Mail size={28} strokeWidth={1.5} />
                </div>
                <h3 className="step-title">Check Your Email</h3>
                <p className="step-description">
                  You&apos;ll receive a confirmation email with your appointment details 
                  and any preparation instructions.
                </p>
              </div>
              
              <div className="step-card">
                <div className="step-icon">
                  <Calendar size={28} strokeWidth={1.5} />
                </div>
                <h3 className="step-title">Your Consultation</h3>
                <p className="step-description">
                  Our provider will review your health history before your scheduled 
                  consultation to make the most of your time together.
                </p>
              </div>
              
              <div className="step-card">
                <div className="step-icon">
                  <Clock size={28} strokeWidth={1.5} />
                </div>
                <h3 className="step-title">Ongoing Support</h3>
                <p className="step-description">
                  After your consultation, you&apos;ll have access to our patient portal 
                  for follow-up questions and care coordination.
                </p>
              </div>
            </div>
          </div>

          <div className="thankyou-contact">
            <p className="body-regular">
              Questions before your appointment? Reach out anytime at{' '}
              <a href="mailto:support@myglowhealth.co" className="contact-link">
                support@myglowhealth.co
              </a>
            </p>
          </div>

          <div className="thankyou-actions">
            <Link to="/" className="btn-primary">
              Return to Home
            </Link>
            <Link to="/services" className="btn-secondary">
              Explore Our Services
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
